import { OctagonAlertIcon } from 'lucide-react';
import { Link } from 'react-router-dom';

import {
  TDAIcon,
  Desafio1a1Icon,
  MiniLigasIcon,
  PremiumCrown,
} from '@/components/Navbar/Icons';
import { useIsDesktop } from '@/hooks/useIsDesktop';
import { AppNotification } from '@/modules/notifications/hooks/useNotifications';

const GiftPinsIcon = () => {
  return (
    <svg
      fill="none"
      height="41"
      viewBox="0 0 41 41"
      width="41"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="20" cy="21" fill="#E3EAFF" r="18" />
      <g clipPath="url(#clip0_1183_162954)">
        <path
          clipRule="evenodd"
          d="M14 20.25C14.4142 20.25 14.75 20.5858 14.75 21V27.75H25.25V21C25.25 20.5858 25.5858 20.25 26 20.25C26.4142 20.25 26.75 20.5858 26.75 21V28.5C26.75 28.9142 26.4142 29.25 26 29.25H14C13.5858 29.25 13.25 28.9142 13.25 28.5V21C13.25 20.5858 13.5858 20.25 14 20.25Z"
          fill="#3366FF"
          fillRule="evenodd"
        />
        <path
          clipRule="evenodd"
          d="M11.75 17.25C11.75 16.8358 12.0858 16.5 12.5 16.5H27.5C27.9142 16.5 28.25 16.8358 28.25 17.25V21C28.25 21.4142 27.9142 21.75 27.5 21.75H12.5C12.0858 21.75 11.75 21.4142 11.75 21V17.25ZM13.25 18V20.25H26.75V18H13.25Z"
          fill="#3366FF"
          fillRule="evenodd"
        />
        <path
          clipRule="evenodd"
          d="M20 16.5C20.4142 16.5 20.75 16.8358 20.75 17.25V28.5C20.75 28.9142 20.4142 29.25 20 29.25C19.5858 29.25 19.25 28.9142 19.25 28.5V17.25C19.25 16.8358 19.5858 16.5 20 16.5Z"
          fill="#3366FF"
          fillRule="evenodd"
        />
        <path
          clipRule="evenodd"
          d="M16.625 14.25C16.3266 14.25 16.0405 14.3685 15.8295 14.5795C15.6185 14.7905 15.5 15.0766 15.5 15.375C15.5 15.6734 15.6185 15.9595 15.8295 16.1705C16.0405 16.3815 16.3266 16.5 16.625 16.5H18.9905C18.899 16.2605 18.7831 15.9971 18.6397 15.7364C18.168 14.8788 17.5204 14.25 16.625 14.25ZM20 17.25C20.7354 17.1029 20.7354 17.1027 20.7353 17.1024L20.7352 17.1018L20.7349 17.1003L20.7341 17.0963L20.7316 17.0842C20.7295 17.0744 20.7266 17.061 20.7229 17.0444C20.7155 17.0112 20.7047 16.9647 20.6903 16.907C20.6614 16.7916 20.6177 16.6301 20.5568 16.4376C20.4358 16.0555 20.2425 15.538 19.954 15.0136C19.3945 13.9962 18.3546 12.75 16.625 12.75C15.9288 12.75 15.2611 13.0266 14.7688 13.5188C14.2766 14.0111 14 14.6788 14 15.375C14 16.0712 14.2766 16.7389 14.7688 17.2312C15.2611 17.7234 15.9288 18 16.625 18H20C20.2247 18 20.4376 17.8993 20.58 17.7255C20.7225 17.5517 20.7795 17.3232 20.7354 17.1029L20 17.25Z"
          fill="#3366FF"
          fillRule="evenodd"
        />
        <path
          clipRule="evenodd"
          d="M20.046 15.0136C20.6055 13.9962 21.6454 12.75 23.375 12.75C24.0712 12.75 24.7389 13.0266 25.2312 13.5188C25.7234 14.0111 26 14.6788 26 15.375C26 16.0712 25.7234 16.7389 25.2312 17.2312C24.7389 17.7234 24.0712 18 23.375 18H20C19.7753 18 19.5625 17.8993 19.42 17.7255C19.2775 17.5517 19.2205 17.3232 19.2646 17.1029L20 17.25C19.2646 17.1029 19.2646 17.1027 19.2647 17.1024L19.2648 17.1018L19.2651 17.1003L19.2659 17.0963L19.2684 17.0842C19.2705 17.0744 19.2734 17.061 19.2771 17.0444C19.2845 17.0112 19.2953 16.9647 19.3098 16.907C19.3386 16.7916 19.3823 16.6301 19.4432 16.4376C19.5642 16.0555 19.7575 15.538 20.046 15.0136ZM21.0095 16.5H23.375C23.6734 16.5 23.9595 16.3815 24.1705 16.1705C24.3815 15.9595 24.5 15.6734 24.5 15.375C24.5 15.0766 24.3815 14.7905 24.1705 14.5795C23.9595 14.3685 23.6734 14.25 23.375 14.25C22.4796 14.25 21.832 14.8788 21.3603 15.7364C21.217 15.9971 21.101 16.2605 21.0095 16.5ZM20.7352 17.3984C20.7351 17.3986 20.7352 17.3985 20.7352 17.3983L20.7352 17.3984Z"
          fill="#3366FF"
          fillRule="evenodd"
        />
      </g>
      <defs>
        <clipPath id="clip0_1183_162954">
          <rect
            fill="white"
            height="18"
            transform="translate(11 12)"
            width="18"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

const getIconForType = (type: string) => {
  const renderIcon = () => {
    if (type.includes('tda')) return <TDAIcon variant="primary" />;
    if (type.includes('desafio')) return <Desafio1a1Icon variant="primary" />;
    if (type.includes('ml')) return <MiniLigasIcon variant="primary" />;
    if (type.includes('pin')) return <GiftPinsIcon />;
    if (['diploma', 'premium_top5', 'voucher'].includes(type))
      return <PremiumCrown />;
    return <OctagonAlertIcon />;
  };

  return (
    <div className="w-10 h-10 rounded-full bg-gdt-blue/10 flex-shrink-0 flex items-center justify-center text-gdt-blue ring-1 ring-gdt-blue/20">
      {renderIcon()}
    </div>
  );
};

const getLinkProps = (idLinkeable?: number) => {
  const isExternal = idLinkeable === 2;
  return {
    target: isExternal ? '_blank' : '_self',
    rel: isExternal ? 'noopener noreferrer' : undefined,
  };
};

const parseMessage = (
  message: string,
  linkUrl?: string,
  idLinkeable?: number
) => {
  const hasBrackets = /\[(.*?)\]/.test(message);
  const linkProps = getLinkProps(idLinkeable);

  // 2) y 3) Si hay corchetes, separo texto normal y texto entre []
  const parts = message.split(/\[(.*?)\]/g).filter((part) => part !== '');

  return parts.map((part, i) => {
    const isBracketText = hasBrackets && i % 2 === 1;

    // 3) Tiene link y corchetes -> solo el texto dentro de [] lleva link
    if (isBracketText && linkUrl) {
      return (
        <Link
          key={i}
          {...linkProps}
          className="text-gdt-blue font-semibold hover:underline"
          to={linkUrl}
        >
          {part}
        </Link>
      );
    }

    // 2) No tiene link y sí corchetes -> texto plano, sin []
    return <span key={i}>{part}</span>;
  });
};

interface Props {
  notification: AppNotification;
}

export const NotificationItem = ({ notification }: Props) => {
  const { isMobile } = useIsDesktop();

  const message = isMobile
    ? notification.raw?.mensajeMobile || notification.message
    : notification.raw?.mensaje;

  const linkUrl = notification.raw?.elink?.linkResp;
  const idLinkeable = notification.raw?.elink?.idLinkeable;
  const hasBrackets = /\[(.*?)\]/.test(`${message}`);
  const isFullItemLink = !!linkUrl && !hasBrackets;

  const inner = (
    <div
      className={`flex gap-4 px-4 items-start py-5 transition-colors border-b border-gray-100 items-center${
        isFullItemLink ? ' hover:bg-gray-50 cursor-pointer' : ''
      }`}
    >
      {getIconForType(notification.type)}
      <div className="flex-1 flex flex-col gap-1 text-left">
        <span className="text-sm font-bold text-gray-900 leading-tight">
          {notification.title}
        </span>
        <p className="text-xs text-gray-600 leading-snug">
          {parseMessage(
            `${message}`,
            isFullItemLink ? undefined : linkUrl,
            idLinkeable
          )}
        </p>
      </div>
    </div>
  );

  if (isFullItemLink) {
    const linkProps = getLinkProps(idLinkeable);
    return (
      <Link {...linkProps} to={linkUrl}>
        {inner}
      </Link>
    );
  }

  return inner;
};

export default NotificationItem;
